import { render, staticRenderFns } from "./vToggleSwitch.vue?vue&type=template&id=090fbb25&scoped=true"
import script from "./vToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./vToggleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./vToggleSwitch.vue?vue&type=style&index=0&id=090fbb25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090fbb25",
  null
  
)

export default component.exports